import React from 'react';
import { AlertCircleIcon, XCircleIcon, CheckCircleIcon, BrainIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-503">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-504">
        <div className="text-center mb-12" data-id="element-505">
          <BrainIcon className="w-12 h-12 text-amber-600 mx-auto mb-4" data-id="element-506" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-507">
            What If the REAL Reason You're Still Tired, Inflamed, Congested, or
            Run-Down…
          </h2>
          <p className="text-xl text-stone-700 leading-relaxed" data-id="element-508">
            …is because modern medicine only masks the symptoms—while the
            problem keeps getting worse?
          </p>
        </div>
        <div className="bg-stone-50 rounded-xl p-8 mb-8" data-id="element-509">
          <p className="text-lg text-stone-700 mb-6 leading-relaxed" data-id="element-510">
            If you've ever felt like your doctor's only answer is a new
            medication… Or like every cold, headache, stomach issue, or
            sleepless night leads you back to pills…
          </p>
          <p className="text-lg text-stone-700 mb-6 leading-relaxed" data-id="element-511">
            You're finally going to see why—and what you can do instead.
          </p>
          <p className="text-lg font-semibold text-stone-900 mb-4" data-id="element-512">
            Because the truth is this:
          </p>
          <div className="space-y-3" data-id="element-513">
            <div className="flex items-start gap-3" data-id="element-514">
              <CheckCircleIcon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-1" data-id="element-515" />
              <p className="text-lg text-stone-700" data-id="element-516">
                Your body is designed to heal itself.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-517">
              <XCircleIcon className="w-6 h-6 text-red-600 flex-shrink-0 mt-1" data-id="element-518" />
              <p className="text-lg text-stone-700" data-id="element-519">
                But when you only treat symptoms, the root problem never gets
                fixed.
              </p>
            </div>
          </div>
        </div>
        <p className="text-lg text-stone-700 text-center leading-relaxed" data-id="element-520">
          For thousands of years, humans relied on plants, herbs, spices, oils,
          and natural ingredients long before pharmacies ever existed. And
          now—modern science is finally catching up, proving what ancient
          cultures always knew.
        </p>
      </div>
    </section>;
}